import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import { schools } from '../variables/schoolList';

export default class UsersFormEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_id    : this.props.match.params.id,
      user_edit  : {
        name     : '',
        lastname : '',
        mobile   : '',
        sex      : '',
        email    : '',
        password : ''
      },
      user       : JSON.parse(localStorage.getItem('tpuser')),
      error      : false,
      success    : false,
      isEditing  : false
    };

    // this.toggleEdit = this.toggleEdit.bind(this);
    this.handleSubmit  = this.handleSubmit.bind(this)
    this.handleChange  = this.handleChange.bind(this);
    this.apiUpdateUser = this.apiUpdateUser.bind(this);
    // this.removeUser    = this.removeUser.bind(this);

  }

  componentDidMount() {
    this.userData();
  }

  handleChange(event){
    const name = event.target.name;
    const user = this.state.user_edit;
    user[name] = event.target.value;
    this.setState({user_edit: user})
  }

  handleSubmit(event) {
    event.preventDefault();
    this.apiUpdateUser();
  }


  userData() {
    fetch(process.env.REACT_APP_API_URL + '/users/' + this.state.user_id, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.state.user.token
      }
    })
    .then( ( response ) => {
      return response.json() 
    })
    .then( ( data ) => {
      this.setState( { user_edit: data })
    })
    .catch( err => console.log(err));
  }

  // toggleEdit(){ this.setState( {isEditing: !this.state.isEditing} ) }

  apiUpdateUser(){
    let self = this;
    fetch(process.env.REACT_APP_API_URL + '/users/' + this.state.user_id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + self.state.user.token
      },
      body: JSON.stringify({ user_edit: self.state.user_edit })
    })
    .then( ( response ) => {
      return response.json() 
    })
    .then( ( data ) => {
      if( data._id ){
        let newUser = {...this.state.user_edit, ...data};
        self.setState({ user_edit: newUser, success: true });
      }else{
        self.setState({ error: true });
      }
    })
    .catch( err => console.log(err));
  }


  render() {

    const alertError = (this.state.error) ? <div className="alert alert-danger"> Oops! </div> : "";
    const alertOk = (this.state.success) ? <div className="alert alert-success"> Cambios realizados con éxito </div> : "";

    return (

      <div id="user-update" className="container">
        <h1 className="upper title margin-bot-20">Perfil</h1>

            <form>
              { alertError }
              { alertOk }
              <div className="form-group">
                <label>Nombre</label>
                <input className="form-control" name="name" value={ this.state.user_edit.name } onChange={ this.handleChange } />
              </div>
              <div className="form-group">
                <label>Apellido</label>
                <input className="form-control" name="lastname" value={ this.state.user_edit.lastname } onChange={ this.handleChange } />
              </div>
              <div className="form-group">
                <label>Telefono</label>
                <input className="form-control" name="mobile" value={ this.state.user_edit.mobile } onChange={ this.handleChange } />
              </div>
              <div className="form-group">
                <label>Sexo</label>
                <select className="form-control" name="sex" value={ this.state.user_edit.sex } onChange={ this.handleChange } >
                  <option value="">Sexo</option>
                  <option value="male">Hombre</option>
                  <option value="female">Mujer</option>
                </select>
              </div>
              <div className="form-group">
                <label>Email</label>
                <input className="form-control disabled" name="email" value={ this.state.user_edit.email }  readOnly disabled />
              </div>
              <div className="form-group">
                <label>Contraseña</label>
                <input className="form-control" name="password" type="password" onChange={ this.handleChange } />
              </div>

                <button className="btn btn-border mr-20" onClick={ this.handleSubmit }>Guardar</button>

            </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/UsersFormEdit.jsx